function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
import { floral, useMultiStyleConfig } from "@thebouqs/system";
import { useDrawer } from "./Drawer.hooks/useDrawer";
import { DrawerMain } from "./DrawerMain";
import { DrawerHandle } from "./DrawerHandle";
export var Drawer = props => {
  var {
    icon,
    position,
    children,
    overlayColor,
    direction = "left"
  } = props;
  var {
    closeButtonLabel,
    handleLabel,
    bodyLabel
  } = props.aria;
  var styles = useMultiStyleConfig("Drawer", {
    variant: direction
  });
  var drawerHandleStyle = useMultiStyleConfig("Button", {
    variant: "unstyled"
  });
  var {
    drawerMainProps,
    drawerContentProps,
    closeButtonProps,
    handleProps,
    onRef
  } = useDrawer({
    direction
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DrawerHandle, _extends({}, handleProps, {
    sx: _extends({}, drawerHandleStyle, styles.handle, {
      pos: position
    }),
    "aria-label": handleLabel
  }), icon), /*#__PURE__*/React.createElement(DrawerMain, _extends({
    sx: styles.drawer,
    ref: onRef,
    overlayColor: overlayColor,
    "aria-label": bodyLabel
  }, drawerMainProps), /*#__PURE__*/React.createElement(DrawerHandle, _extends({}, closeButtonProps, {
    sx: _extends({}, drawerHandleStyle, styles.closeButton),
    "aria-label": closeButtonLabel
  }), "X"), /*#__PURE__*/React.createElement(floral.div, _extends({}, drawerContentProps, {
    sx: styles.body
  }), children)));
};
//# sourceMappingURL=Drawer.js.map